import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './LabelListItemContent.module.css'

function LabelListItemContent({ isActive, isHovered, showTooltip, value }) {
  const {
    is_persistent: isPersistent,
    label: { color, textColor, title },
    value: id,
  } = value

  const { overflow: textOverlfow, setContentOverflowRef } = useContentOverflow()

  const { t } = useTranslation()

  const textClassName = classNames(styles.text, {
    [styles.hover]: isActive || isHovered,
  })

  return (
    <>
      {id && !isPersistent ? (
        <FloatingTooltip
          content={title}
          disabled={!showTooltip || !textOverlfow}
        >
          <div
            className={styles.label}
            ref={setContentOverflowRef}
            style={{
              '--list-item-label-bg-color': color,
              '--list-item-label-text-color': textColor,
            }}
          >
            {title}
          </div>
        </FloatingTooltip>
      ) : (
        <FloatingTooltip
          content={t(title)}
          disabled={!showTooltip || !textOverlfow}
        >
          <Text className={textClassName} ref={setContentOverflowRef}>
            {t(title)}
          </Text>
        </FloatingTooltip>
      )}
    </>
  )
}

export default LabelListItemContent
